/** Chat composer'ına eklenebilecek maksimum dosya sayısı */
export const CHAT_MAX_ATTACHMENTS = 10;
